import * as Yup from 'yup';
import { Proposer } from '@models';

export function useValidationSchema() {
  return Yup.object<Proposer>().shape({
    contact: Yup.string().nullable().required(),
  });
}
